<template>
    <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

            <!-- <li class="nav-item" v-for="(data, x) in modules" :key="data.id">
                <router-link :to="'/'+ data.path" class="nav-link">
                    <i :class="'nav-icon '+ data.icon"></i>
                    <p>
                        {{ data.name }}
                    </p>
                </router-link>

            </li> -->
            <li class="nav-item" key="dashboard">
                <router-link to="/dashboard" class="nav-link" @click.native="handleSidebarClick('/dashboard')">
                    <i class="nav-icon fas fa-tachometer-alt blue"></i>
                    <p>
                       Dashboard
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==3">
                <router-link to="/complaint" class="nav-link" @click.native="handleSidebarClick('/complaint')">
                    <i class="nav-icon fas fa-arrow-left"></i>
                    <p>
                       Lodge A New Fault
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==3">
                <router-link to="/complaint-list/1" class="nav-link" @click.native="handleSidebarClick('/complaint-list/1')">
                    <i class="nav-icon fas fa-eye"></i>
                    <p>
                       Ticket Details
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==4">
                <router-link to="/complaint-list/1" class="nav-link" @click.native="handleSidebarClick('/complaint-list/1')">
                    <i class="nav-icon fas fa-eye"></i>
                    <p>
                       FLM
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.is_bna || authUser.id_cms_privileges==4">
                <router-link to="/complaint-list/2" class="nav-link" @click.native="handleSidebarClick('/complaint-list/2')">
                    <i class="nav-icon fas fa-eye"></i>
                    <p>
                        Dispenser Joined Call
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==4">
                <router-link to="/sls-list" class="nav-link" @click.native="handleSidebarClick('/sls-list')">
                    <i class="nav-icon fas fa-eye"></i>
                    <p>
                       SLM
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/states" class="nav-link" @click.native="handleSidebarClick('/states')">
                    <i class="nav-icon fas fa-globe"></i>
                    <p>
                       States
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/districts" class="nav-link" @click.native="handleSidebarClick('/districts')">
                    <i class="nav-icon fas fa-globe"></i>
                    <p>
                       Districts
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/cities" class="nav-link" @click.native="handleSidebarClick('/cities')">
                    <i class="nav-icon fas fa-globe"></i>
                    <p>
                       Cities
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/postcodes" class="nav-link" @click.native="handleSidebarClick('/postcodes')">
                    <i class="nav-icon fas fa-globe"></i>
                    <p>
                       Postcode
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/areacodes" class="nav-link" @click.native="handleSidebarClick('/areacodes')">
                    <i class="nav-icon fas fa-globe"></i>
                    <p>
                       Areacode
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/complaint-types" class="nav-link" @click.native="handleSidebarClick('/complaint-types')">
                    <i class="nav-icon fas fa-file"></i>
                    <p>
                       Complaint Types
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/banks" class="nav-link" @click.native="handleSidebarClick('/banks')">
                    <i class="nav-icon fas fa-landmark"></i>
                    <p>
                       Bank
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/clients" class="nav-link" @click.native="handleSidebarClick('/clients')">
                    <i class="nav-icon fas fa-user"></i>

                    <p>
                       Client
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/cms_users" class="nav-link" @click.native="handleSidebarClick('/cms_users')">
                    <!-- <i :class="'nav-icon '+ data.icon"></i> -->
                    <i class="nav-icon fas fa-user-plus"></i>
                    <p>
                       Manage Client Code
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/call_center_users" class="nav-link" @click.native="handleSidebarClick('/call_center_users')">
                    <!-- <i :class="'nav-icon '+ data.icon"></i> -->
                    <i class="nav-icon fas fa-users"></i>
                    <p>
                       Manage Call Center User
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/custodians" class="nav-link" @click.native="handleSidebarClick('/custodians')">
                    <i class="nav-icon fas fa-user-plus"></i>
                    <p>
                       Manage Custodian
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/atms" class="nav-link" @click.native="handleSidebarClick('/atms')">
                    <i class="nav-icon fas fa-cog"></i>
                    <p>
                       Atm
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/admin-complaints" class="nav-link" @click.native="handleSidebarClick('/admin-complaints')">
                    <i class="nav-icon fas fa-cogs"></i>
                    <p>
                       Manage Complaint
                    </p>
                </router-link>

            </li>
            <li class="nav-item" v-if="authUser.id_cms_privileges==2">
                <router-link to="/reports" class="nav-link" @click.native="handleSidebarClick('/reports')">
                    <i class="nav-icon fas fa-file-excel"></i>
                    <p>
                        Report
                    </p>
                </router-link>

            </li>
            <li class="nav-item">
                <router-link to="/account" class="nav-link" @click.native="handleSidebarClick('/account')">
                    <i class="nav-icon fas fa-cog"></i>
                    <p>
                       Account Details
                    </p>
                </router-link>

            </li>
        </ul>
    </nav>
  </template>

  <script>
  import axios from 'axios';

  export default {
    data() {
      return {
        modules: [],
        authUser: localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : null,
      };
    },
    mounted() {
        this.authUser=localStorage.getItem("auth");
        if (this.authUser) {
            this.authUser = JSON.parse(this.authUser);
        }
      axios.get('/api/account-auth')
        .then(response => {


          console.log("response module");
          console.log(response.data.data);
          localStorage.setItem("auth", JSON.stringify(response.data.data));
          this.authUser=localStorage.getItem("auth");
        if (this.authUser) {
            this.authUser = JSON.parse(this.authUser);
        }
        })
        .catch(error => {
          console.error('Error fetching modules:', error);
        });
    },
    methods: {
        clearPagination() {
            const keys = [
                'ticket_list_page', 'ticket_list_page_base',
                'sls_list_page', 'sls_list_page_base',
                'master_report_page', 'master_report_page_base',
                'ticket_report_page', 'ticket_report_page_base',
                'machine_list_page', 'machine_list_page_base',
                'maintenance_list_page', 'maintenance_list_page_base',
                'reading_list_page', 'reading_list_page_base',
                'admin_complaint_page', 'admin_complaint_page_base',
                'atm_list_page', 'atm_list_page_base',
                'custodian_list_page', 'custodian_list_page_base',
                'flm_list_page', 'flm_list_page_base',
                'dispenser_list_page', 'dispenser_list_page_base'
            ];
            
            // Handle dynamic complaint list keys
            Object.keys(localStorage).forEach(key => {
                if (key && (key.startsWith('complaint_list_page_') || key.startsWith('complaint_list_page_base_') || key.startsWith('complaint_list_search_'))) {
                    localStorage.removeItem(key);
                }
            });

            keys.forEach(key => localStorage.removeItem(key));
        },
        handleSidebarClick(to) {
            this.clearPagination();
            if (this.$route.path === to) {
                this.$router.go(0);
            }
        },
        redirecturl(url){
        console.log("hello");
        // $router.push(url)
        window.location.href=url;

     },
      hasRequiredPermission(permissionNames) {
        if (!permissionNames || !Array.isArray(permissionNames)) {
            return false;
        }
        return permissionNames.some(permission => permission.required === "yes");
      },
      route(name) {
        return this.$route(name);
      }
    }
  };
  </script>

  <style>
  /* Add your custom styles here */
  </style>
